var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildingVerification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35235",
    "data-name": "Group 35235",
    transform: "translate(-757.7 -295)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9815",
    "data-name": "Rectangle 9815",
    width: 40,
    height: 40,
    transform: "translate(757.7 295)",
    fill: "red",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_35290",
    "data-name": "Group 35290",
    transform: "translate(763.534 298)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72305",
    "data-name": "Path 72305",
    d: "M76.333,16.444h6.3",
    transform: "translate(-68.967 8.111)",
    fill: "none",
    stroke: "#f49c43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72306",
    "data-name": "Path 72306",
    d: "M76.333,12.5H86.407",
    transform: "translate(-68.967 5.35)",
    fill: "none",
    stroke: "#f49c43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72307",
    "data-name": "Path 72307",
    d: "M89.438,2H78.221A5.162,5.162,0,0,0,73,7.1V30.9A5.162,5.162,0,0,0,78.221,36h4.448M89.438,2l10.636,10.625M89.438,2v8.925a1.721,1.721,0,0,0,1.74,1.7h8.9m0,0v7.91",
    transform: "translate(-73 -2)",
    fill: "none",
    stroke: "#f49c43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72308",
    "data-name": "Path 72308",
    d: "M81.889,20.222l2.518,2.518,6.3-6.3",
    transform: "translate(-62.371 11.259)",
    fill: "none",
    stroke: "#f49c43",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildingVerification);
export default __webpack_public_path__ + "static/media/building-verification.6850344d62df63e2c9799cc404fb4002.svg";
export { ForwardRef as ReactComponent };